import { render, staticRenderFns } from "./show.vue?vue&type=template&id=6f87ba2f&"
import script from "./show.js?vue&type=script&lang=js&"
export * from "./show.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports